import styled from '@emotion/styled';
import { type ComponentProps } from 'react';

import Box from '~/common/components/Box';
import Text from '~/common/components/Texts/Text';

const DlStyled = styled.dl`
  margin-top: 4px;
  margin-bottom: 4px;
  display: flex;
  align-items: flex-end;
`;
const DtStyled = styled.dt`
  float: left;
  clear: left;
  font-weight: 500;
  margin-right: 4px;
  &:after {
    content: ':';
  }
`;

type DataDisplayBlockProps = {
  containerProps?: ComponentProps<typeof Box>;
  data: {
    label?: string;
    value?: string;
  }[];
  ddProps?: Record<string, number | string>;
  dlProps?: Record<string, unknown>;
  dtProps?: Record<string, unknown>;
  header?: string | React.ReactNode;
  headerProps?: ComponentProps<typeof Text>;
};

const DataDisplayBlock = ({
  header,
  data,
  containerProps,
  headerProps,
  dlProps,
  dtProps,
  ddProps,
}: DataDisplayBlockProps) => (
  <Box {...containerProps}>
    {header && (
      <Text as="h4" {...headerProps}>
        {header}
      </Text>
    )}
    {data.map(({ label, value }) => (
      <Box as={DlStyled} key={`${label}-${value}`} {...dlProps}>
        <Text as={DtStyled} {...dtProps}>
          {label}
        </Text>
        <Text as="dd" {...ddProps}>
          {value}
        </Text>
      </Box>
    ))}
  </Box>
);

DataDisplayBlock.defaultProps = {
  containerProps: {},
  ddProps: {},
  dlProps: {},
  dtProps: {},
  header: null,
  headerProps: { mb: '14px' },
};

export default DataDisplayBlock;
